import { Container, ContainerProps } from "@mui/material";
import React from "react";
import utils from "../Services/Utils";
// import Footer from "./Footer";

import { HeaderLoadable } from "./LoadableComponents";

export default function MainLayout({
  children,
  noContainer,
  containerProps,
  hideHeader,
}: {
  children: any;
  noContainer?: boolean;
  containerProps?: ContainerProps;
  hideHeader?: boolean;
}) {
  React.useEffect(() => {
    utils.fireEvent("onAppLoaded");
  }, []);
  function renderChild() {
    if (noContainer) return children;
    return <Container {...containerProps}>{children}</Container>;
  }
  return (
    <main>
      {!hideHeader && <HeaderLoadable />}
      <div style={{ minHeight: window.innerHeight - 100 }}>{renderChild()}</div>
      {/* <Footer /> */}
    </main>
  );
}
